import * as moment from 'moment';
import {ActivatedRoute} from '@angular/router';
import {CommonService} from '../services/common.service';
import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';

@Component({
  styleUrls: ['./pdf-sample.component.scss'],
  templateUrl: './pdf-sample.component.html'
})
export class PdfSampleComponent implements OnInit {
  @ViewChild('pdfTable', {static: false}) pdfTable: ElementRef;

  public repairId: number;
  public repairInfo: RepairInfo;
  public canShowInfo: boolean;
  public details: Details[];
  public pages: number;
  public damagesNumber: number;
  public specialDamagesNumber: number;
  public repairsDone: number;
  public title: string;

  constructor(private activatedRoute: ActivatedRoute,
              private commonService: CommonService) {
  }

  public ngOnInit(): void {
    this.canShowInfo = false;
    this.activatedRoute.params.subscribe(async (params) => {
      this.repairId = +params.id;
      await this.getRepairInfo(params.id);
    });
  }

  async getRepairInfo(id: number) {
    try {
      this.repairInfo = await this.commonService.getSimpleList(`repair/web/${id}`) as RepairInfo;
      this.title = this.repairInfo.type_id === 3 ? 'Πληροφορίες εντολής επισκευής' : 'Πληροφορίες εντολής συντήρησης';
      this.details = this.repairInfo.details;
      this.pages = this.details.length;
      this.damagesNumber = 0;
      this.specialDamagesNumber = 0;
      this.repairsDone = 0;
      if (this.repairInfo.type_id !== 1) {
        for (const fridge of this.details) {
          this.damagesNumber += fridge.damages.length;
          this.specialDamagesNumber += fridge.special_damages.length;
          this.repairsDone += fridge.repairs.length;
        }
      } else {
        this.damagesNumber = 0;
        this.specialDamagesNumber = 0;
        this.repairsDone = 0;
      }
      const tempDate = new Date(this.repairInfo.expected_date);
      const tempCreatedDate = new Date(this.repairInfo.date_created);
      const tempRoutedDate = new Date(this.repairInfo.routing_date);

      if (!isNaN(tempRoutedDate.getTime())) {
        if (this.repairInfo.routing_date !== null) {
          this.repairInfo.routedAt = moment(this.repairInfo.routing_date).format('DD-MM-YYYY');
        } else {
          this.repairInfo.routedAt = '-';
        }
      }

      if (!isNaN(tempCreatedDate.getTime())) {
        if (this.repairInfo.date_created !== null) {
          this.repairInfo.createdAt = moment(this.repairInfo.date_created).format('DD-MM-YYYY');
        } else {
          this.repairInfo.createdAt = '-';
        }
      }

      if (this.repairInfo.expected_date !== null) {
        this.repairInfo.expectedDateToString = moment(this.repairInfo.expected_date).format('DD-MM-YYYY');
      } else {
        this.repairInfo.expectedDateToString = '-';
      }


      this.canShowInfo = true;

    } catch (e) {
    }
  }
}

interface RepairInfo {
  id: number;
  created_by_id: number;
  created_by_name: string;
  expected_date: Date;
  expectedDateToString?: string;
  date_created: Date;
  createdAt: any;
  routing_date: Date;
  routedAt: any;
  date_completed: Date;
  completedAt: any;
  distribution_center_id: number;
  distribution_center_name: string;
  technician_id: number;
  technician_name: string;
  status_id: number;
  type_id: number;
  type_description: string;
  status_description: string;
  sale_point: SalePointInfo;
  details: Details[];
}

interface SalePointInfo {
  id: number;
  name: string;
  city: string;
  address: string;
  postal_code: string;
  sales_organization_id: number;
  account_group_id: string;
}

interface Details {
  id: number;
  serial_number: string;
  material_id: string;
  material_description: string;
  refrigerator_type_id: number;
  refrigerator_type_description: string;
  product_status_id: number;
  product_status_description: string;
  temperature: string;
  comments: string;
  repair_date: Date;
  damages: Damage[];
  special_damages: SpecialDamage[];
  repairs: any;
  files: File[];
}

interface Damage {
  repair_details_damage_id: number;
  id: number;
  description: string;
  is_special: number;
}

interface File {
  file_id: number;
  file_path: string;
  file_name: string;
  file_size: string;
}

interface SpecialDamage {
  repair_details_special_damage_id: number;
  id: number;
  description: string;
}
